import { h } from "hyperapp";

import { format } from "date-fns";
import jQuery from "jquery";

import listCSS from "./list.css";

import { addressRenderer } from "../../common/address-renderer/address-renderer";
import { columnIsSelected } from "../../common/column-selector/utils/column-is-selected";
import { contactRenderer } from "../../common/contact-renderer/contact-renderer";
import { areAllSelected } from "../../common/list-item-selector/utils/are-all-selected";
import { portifoliosRenderer } from "../../common/portifolios-renderer/portifolios-renderer";

export const list = ({
  actions,
  section,
  state,
  translations,
}): JSX.Element => {
  const { setAllSelected, setSelected } = actions;

  const { categories } = state;

  const { columns, items, id: nearbyID, selected } = state[section];

  return (
    <div class="table-responsive card">
      <table class="table">
        <thead class="card-header">
          <tr>
            <th class={listCSS.singleIconColumn}>
              <div class="custom-control custom-checkbox">
                <input
                  class="custom-control-input"
                  checked={areAllSelected({ items, selected })}
                  disabled={items.length === 0}
                  id="selectAllItemsOnCurrentPage"
                  onchange={event =>
                    setAllSelected({ section, select: event.target.checked })
                  }
                  type="checkbox"
                />
                <label
                  class="custom-control-label"
                  for="selectAllItemsOnCurrentPage"
                />
              </div>
            </th>
            <th class={listCSS.singleIconColumn} />
            <th scope="col">{translations["name"]}</th>
            <th scope="col" />
            <th scope="col">{translations["distance"]}</th>
            {columnIsSelected({ columnID: "address", columns }) && (
              <th scope="col">{translations["address"]}</th>
            )}
            {columnIsSelected({ columnID: "category", columns }) && (
              <th scope="col">{translations["category"]}</th>
            )}
            {columnIsSelected({ columnID: "cnpj_cpf", columns }) && (
              <th scope="col">{translations["CNPJ"]}</th>
            )}
            {columnIsSelected({ columnID: "contacts", columns }) && (
              <th scope="col">{translations["contact"]}</th>
            )}
            {columnIsSelected({ columnID: "corporate_name", columns }) && (
              <th scope="col">{translations["companyName"]}</th>
            )}
            {columnIsSelected({ columnID: "status", columns }) && (
              <th scope="col">{translations["status"]}</th>
            )}
            {columnIsSelected({ columnID: "portifolios", columns }) && (
              <th scope="col">{translations["portifolios"]}</th>
            )}
            {columnIsSelected({ columnID: "id", columns }) && (
              <th scope="col">ID</th>
            )}
          </tr>
        </thead>
        <tbody>
          {items.map(
            ({
              address,
              category_id: categoryID,
              cnpj_cpf: cnpjCPF,
              contacts,
              corporate_name: corporateName,
              distance,
              id,
              last_pending_schedule,
              name,
              portifolios,
              status,
            }) => {
              const category = categories.find(
                category => category.id === categoryID,
              );

              const isSelected =
                selected.findIndex(item => item.id === id) !== -1;

              return (
                <tr
                  class={isSelected ? "table-info" : ""}
                  onclick={() =>
                    setSelected({
                      section,
                      select: !isSelected,
                      value: id,
                    })
                  }
                  style="cursor: pointer;"
                >
                  <td class={listCSS.singleIconColumn}>
                    <div class="custom-control custom-checkbox">
                      <input
                        checked={isSelected}
                        class="custom-control-input"
                        id={id}
                        onchange={() =>
                          setSelected({
                            section,
                            select: !isSelected,
                            value: id,
                          })
                        }
                        type="checkbox"
                        value={id}
                      />
                      <label class="custom-control-label" for={id} />
                    </div>
                  </td>
                  <td>
                    <div>
                      {last_pending_schedule ? (
                        <i
                          class={"material-icons " + listCSS.scheduleIcon}
                          data-placement="top"
                          onclick={event =>
                            jQuery(event.target).tooltip("hide")
                          }
                          title={`${
                            translations["thereIsAPendingScheduleTo"]
                          } ${format(
                            last_pending_schedule,
                            "DD/MM/YYYY HH:mm",
                          )}`}
                        >
                          schedule
                        </i>
                      ) : (
                        <span />
                      )}
                    </div>
                  </td>
                  <td scope="row">
                    <div>{name}</div>
                  </td>
                  <td scope="row">
                    <div>
                      <div>
                        {id === nearbyID ? (
                          <span
                            class="badge badge-info"
                            data-placement="top"
                            title={translations["message"]}
                          >
                            Local de Referência
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </td>
                  <td class={listCSS.numberCell}>
                    <div>
                      {new Intl.NumberFormat("pt-BR").format(distance)} m
                    </div>
                  </td>
                  {columnIsSelected({ columnID: "address", columns }) &&
                    (address ? (
                      <td>
                        <div>{addressRenderer({ address })}</div>
                      </td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <div>
                          <i>Sem endereço</i>
                        </div>
                      </td>
                    ))}
                  {columnIsSelected({ columnID: "category", columns }) &&
                    (category ? (
                      <td>
                        <div>{category.name}</div>
                      </td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <div>
                          <i>Não categorizado</i>
                        </div>
                      </td>
                    ))}
                  {columnIsSelected({ columnID: "cnpj_cpf", columns }) && (
                    <td style="white-space: nowrap;">
                      <div>{cnpjCPF}</div>
                    </td>
                  )}
                  {columnIsSelected({ columnID: "contacts", columns }) &&
                    (contacts ? (
                      <td>
                        <div>{contactRenderer({ contacts })}</div>
                      </td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <div>
                          <i>Sem contato</i>
                        </div>
                      </td>
                    ))}
                  {columnIsSelected({
                    columnID: "corporate_name",
                    columns,
                  }) && (
                    <td>
                      <div>{corporateName}</div>
                    </td>
                  )}
                  {columnIsSelected({ columnID: "status", columns }) && (
                    <td>
                      <div>{status}</div>
                    </td>
                  )}
                  {columnIsSelected({ columnID: "portifolios", columns }) &&
                    (portifolios && portifolios.length > 0 ? (
                      <td>
                        <div>{portifoliosRenderer({ portifolios })}</div>
                      </td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <div>
                          <i>Sem carteira</i>
                        </div>
                      </td>
                    ))}
                  <td>
                    {columnIsSelected({ columnID: "id", columns }) && (
                      <div>
                        <span class={listCSS.uuid}>{id}</span>
                      </div>
                    )}
                  </td>
                </tr>
              );
            },
          )}
        </tbody>
      </table>
    </div>
  );
};
